import { BasicValidationService } from '../../../../../shared/services/BasicValidationService';

export class AppValidationService extends BasicValidationService<MyVehicleAppDefinition> {

	protected addCustomMethods(): void {
		super.addCustomMethods();

		$.validator.addMethod("noemojis", function (value, element, params): boolean {
			if (params && value) {
				const re = /(\ud83c[\udc00-\udfff])+/i;
				return !re.test(value);
			}
			return true;
		});

		$.validator.addMethod("numberplatecross", function (value, element, params): boolean {
			if (params.length !== 3) {
				console.log('params must have a length of 3');
				return false;
			}
			const $element = $(element);
			const $plate1 = $element.closest('.js-row').find(`input[name="${params[0]}"]`);
			const $plate2 = $element.closest('.js-row').find(`input[name="${params[1]}"]`);
			const $plate3 = $element.closest('.js-row').find(`input[name="${params[2]}"]`);
			//only return false if some fields are filled and some not
			if (($plate1.val() || $plate2.val() || $plate3.val()) && (!$plate1.val() || !$plate2.val() || !$plate3.val())) {
				return false;
			}
			return true;
		});
	}

	protected fillLookupServerFieldnames(): void {
		super.fillLookupServerFieldnames();

		this.lookupServerFieldnames["FahrzeugFarbe"] = "color";
		this.lookupServerFieldnames["Zulassung"] = "number-plate";
		this.lookupServerFieldnames["Marke"] = "brand";
		this.lookupServerFieldnames["Baureihe"] = "family";
		this.lookupServerFieldnames["Modell"] = "modell";
		this.lookupServerFieldnames["Name"] = "title";
		this.lookupServerFieldnames["Karosserie"] = "coachwork";
	}

	public handleServerValidationErrors(jqxhr: JQueryXHR): void {
		// This is a edited version of 'showServerValidationErrors'.
		// It is maybe a candidate to refactor or extend the original method.
		// It was necessary to get the 'setServerValidationBackendFlag' call within this method.
		$.each(jqxhr.responseJSON.Messages.reverse(), (key, item) => {
			if (item.CancelledOnValidation) {
				const errorSource = item.Source;
				const fieldnameIndex = errorSource.lastIndexOf('.');
				const fieldName = errorSource.substr(fieldnameIndex + 1);

				if (item.Id === 187022) {
					// Kennzeichen existierte bereits
					this.setServerValidationBackendFlag(false, "plate_1", item.Id);
				} else {
					if (fieldName in this.lookupServerFieldnames) {
						this.setServerValidationBackendFlag(false, this.lookupServerFieldnames[fieldName], item.Id);
					}
				}
			}
		});
	}
}
